import React from 'react';
import { store } from '../redux/store';
import { Provider } from 'react-redux';

interface StoreProviderProps {
    readonly children: React.ReactNode;
}

export default function OpenBankStoreProvider({ children }: StoreProviderProps) {
    return (
        <Provider store={store}>
            {children}
        </Provider>
    )
}